import React, { Component } from 'react'
import { connect } from 'react-redux'
import { isEqual } from 'lodash'
import { showPopupParts, setCarSelectedParts } from '../../../../../actions/price'

import { translation } from '../../../../../utils/helpers'
import Text from '../../../../elements/text'
import Check from '../../../../elements/check'
import Divider from '../../../../elements/divider'
import Button from '../../../../elements/button'
import Inline from '../../../../elements/inline'

class OtherDamageList extends Component {
  constructor (props) {
    super(props)
    this.state = {
      selectedPart: {},
      selectedBodyPart: undefined,
      showPopupForParts: this.props.showPopupForParts === true,
      selectedPartsOriginal: [],
      carItems: this.props.carItems,
      carPartItems: []
    }

    this.init = this.init.bind(this)
    this.reset = this.reset.bind(this)
    this.setSelectedProp = this.setSelectedProp.bind(this)
    this.close = this.close.bind(this)
    this.submit = this.submit.bind(this)
    this.onChange = this.onChange.bind(this)
    this.renderInputs = this.renderInputs.bind(this)

    this.manualTaskId = 9000000000000000
  }

  componentDidMount () {
    this.init(this.props)
  }

  componentWillUnmount () {
    this.reset()
  }

  componentWillReceiveProps (nextProps) {
    if (this.props.showPopupForParts !== nextProps.showPopupForParts ||
      this.props.selectedBodyPart !== nextProps.selectedBodyPart ||
      this.props.selectedBodyPartSide !== nextProps.selectedBodyPartSide ||
      !isEqual(this.props.carItems, nextProps.carItems)) {
      if (nextProps.showPopupForParts) {
        this.init(nextProps)
      } else {
        this.reset(nextProps)
      }
    }
  }

  init (props) {
    this.reset(props)
    if (props.showPopupForParts !== true) return null
    this.setState({
      selectedBodyPart: props.selectedBodyPart,
      showPopupForParts: props.showPopupForParts === true
    }, () => {
      this.setSelectedProp()
    })
  }

  reset (props) {
    this.manualTaskId = 9000000000000000
    this.setState({
      selectedPart: {},
      selectedBodyPart: !props ? null : props.selectedBodyPart,
      showPopupForParts: !props ? false : props.showPopupForParts,
      carItems: !props ? [] : props.carItems,
      carPartItems: []
    })
  }

  setSelectedProp () {
    const part = this.state.selectedBodyPart
    const carItems = this.state.carItems

    let hasCustomSelected = false
    let additionalCustomParts = []
    let carPartItems = carItems.map(cItem => {
      const item = { ...cItem }

      item.id = part + '_' + item.EnumValue
      item.IsSelected = false

      const validOtherDamage = this.props.price.OtherDamages.find(od => !od.Active)

      this.props.price.Parts.forEach(pricePart => {
        let indexI = part.indexOf(pricePart.Part.MappingName)
        let indexV = part.indexOf('venstre-')
        let indexH = part.indexOf('hojre-')
        let indexF = part.indexOf('-for')
        let indexB = part.indexOf('-bag')

        const isMiddle = indexI === 0 && pricePart.Part.TaskSide === 0
        const isLeft = indexV === 0 && pricePart.Part.TaskSide === 1
        const isRight = indexH === 0 && pricePart.Part.TaskSide === 2
        const isLeftFront = indexV === 0 && indexF !== -1 && pricePart.Part.TaskSide === 5
        const isRightFront = indexH === 0 && indexF !== -1 && pricePart.Part.TaskSide === 6
        const isLeftBack = indexV === 0 && indexB !== -1 && pricePart.Part.TaskSide === 7
        const isRightBack = indexH === 0 && indexB !== -1 && pricePart.Part.TaskSide === 8

        if ((isMiddle) ||
        (indexI > -1 && (isLeft || isRight || (isLeftFront || isRightFront || isLeftBack || isRightBack)))) {
          pricePart.OtherDamages.forEach(od => {
            if (od.Type === item.EnumValue && od.OtherDamageId === validOtherDamage.Id) {
              item.IsSelected = true

              if (od.Type === 10) {
                // For not the first item
                if (hasCustomSelected) {
                  additionalCustomParts = [...additionalCustomParts, { ...item, CustomName: od.CustomName }]
                } else {
                  item.CustomName = od.CustomName
                }

                hasCustomSelected = true
              }
            }
          })
        }
      })
      return item
    })

    carPartItems = [...carPartItems, ...additionalCustomParts]

    if (hasCustomSelected) {
      carPartItems = [...carPartItems, this.createBlankDamage(this.state.selectedBodyPart)]
    }

    this.setState({
      carPartItems: carPartItems
    })

    return carItems
  }

  createBlankDamage (part) {
    return {
      id: part + '_' + ++this.manualTaskId,
      EnumValue: 10,
      IsSelected: false,
      name: 'Andet',
      CustomName: null
    }
  }

  close () {
    this.reset(this.props)
    this.setState({
      carItems: []
    })
    this.props.close()
  }

  submit () {
    const { carPartItems } = this.state
    const extents = carPartItems.filter(cpi => cpi.IsSelected)

    this.props.setCarSelectedParts(extents)
    this.close()
  }

  onChange (e) {
    const { id, name, value, checked } = e.target
    let { carPartItems } = { ...this.state }
    const item = carPartItems.find(cpi => cpi.id === id)

    if (name !== 'CustomDamage') {
      item.IsSelected = checked
    } else {
      let isNew = false

      if (!item.IsSelected) {
        item.IsSelected = true
        isNew = true

        const isLast = carPartItems.indexOf(item) === carPartItems.length - 1
        if (isLast) {
          carPartItems = [...carPartItems, this.createBlankDamage(this.state.selectedBodyPart)]
        }
      }

      item.CustomName = id !== value ? value : ''

      if (!isNew && item.CustomName.length === 0) {
        item.IsSelected = false

        const lastItem = carPartItems[carPartItems.length - 1]
        if (!lastItem.IsSelected && lastItem.name === 'Andet' && item.id !== lastItem.id) {
          carPartItems = carPartItems.filter(cpi => cpi.id !== item.id)
        }
      }
    }

    this.setState({
      carPartItems
    })
  }

  renderInputs (item, key) {
    const id = item.id
    const isSelected = item.IsSelected
    const isCustom = item.EnumValue === 10

    // let checkboxClass = 'carCheckbox__custom'
    // if (isCustom) checkboxClass += ' custom'

    return (
      <div key={key}>
        {!isCustom && <Check id={id} name={!isCustom ? id : 'CustomDamage'} value={id} checked={isSelected} onChange={this.onChange} labelText={!isCustom && item.name} spacing={1} />}
        {isCustom && (
          <Inline spacing={0} alignChildren='center'>
            <Check id={id} name={!isCustom ? id : 'CustomDamage'} value={id} checked={isSelected} onChange={this.onChange} spacing={1} />
            <Text size='s' id={id} name={'CustomDamage'} value={item.CustomName || ''} placeholder={translation('227')} onChange={this.onChange} />
          </Inline>
        )}
      </div>
    )
  }

  render () {
    if (this.props.showPopupForParts !== true) return null
    if (window.carHandler.priceCalcType !== 30) return null

    const inputs = this.state.carPartItems

    return (
      <div>
        {inputs.map(this.renderInputs)}

        <Divider size={3} noLine />
        <Button onClick={this.submit} labelText={translation('1208')} />
      </div>
    )
  }
}

OtherDamageList.propTypes = {
  close: React.PropTypes.func.isRequired
}

function mapStateToProps (state) {
  return {
    price: state.price.price,
    showPopupForParts: state.price.showPopupForParts,
    selectedBodyPart: state.price.selectedBodyPart,
    selectedBodyPartSide: state.price.selectedBodyPartSide,
    carItems: state.price.carItems
  }
}

export default connect(mapStateToProps, {
  showPopupParts,
  setCarSelectedParts
})(OtherDamageList)



// WEBPACK FOOTER //
// ./src/app/shared/components/Car/CarPopup/OtherDamageList/index.js